import { type Command, TokenPaginationOptions } from '@telespot/core';

export const LIST_USERS = 'users:list';

export interface UserItem {
  id: string;
  affiliationId: string | undefined;
  username: string;
  emailVerified: boolean;
  avatarUrl: string | undefined;

  /**
   * Date when the user was affiliated to the organization.
   * It is not 100% accurate when the user has just been created, containing the creation date instead of the affiliation date.
   * This does not have an impact on anything, because the user has been created specifically for the organization,
   * and has been affiliated as soon as it was created. When the user list is refreshed, the affiliation date is updated to the correct value.
   */
  affiliationDate: Date;
}

export interface UserFilters {
  username: string;
}

export interface ListUsersPayload extends TokenPaginationOptions<UserItem> {
  /**
   * Organization ID
   */
  organizationId: string;
  /**
   * Filters for narrowing down users
   */
  filters?: UserFilters;
}

export class ListUsers implements Command<typeof LIST_USERS, ListUsersPayload> {
  public readonly name = LIST_USERS;
  constructor(public readonly details: Readonly<ListUsersPayload>) {}
}
